import Media from 'react-media';
import ReactMarkdown from 'react-markdown';

import { useTheme } from '@simplywallst/ui-core';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import type { HomeCms } from '@/components/OurPlans/query';
import { OneColumn } from '@/components/Layout';
import Carousel, { Slides, Slide } from '@/components/Carousel';

import { TrustBox } from '@/pages/Home';

import {
  ReviewContainerRow,
  ReviewCarouselRow,
  StyledReactMarkdown,
  StyledReviewReactMarkdown,
} from './styled';

export const Reviews = ({ markdownContent }: HomeCms) => {
  const theme = useTheme();
  const { isMobile, isTablet, isDesktop } = useUserAgent();
  return (
    <ReviewContainerRow justifyContent="center" data-cy-id="review">
      <OneColumn>
        <TrustBox boxType="small" />
        <StyledReactMarkdown>
          <ReactMarkdown source={markdownContent && markdownContent[0]} />
        </StyledReactMarkdown>
      </OneColumn>
      <ReviewCarouselRow>
        {markdownContent && markdownContent.length > 0 && (
          <>
            <Media
              query={{ maxWidth: theme.mdMaxRaw }}
              defaultMatches={isMobile || isTablet}
              render={() => (
                <Carousel
                  autoPlay
                  autoPlaySpeed={10000}
                  totalSlides={markdownContent.length - 1}
                  showDots
                >
                  <Slides>
                    {markdownContent
                      .slice(1)
                      .filter((review) => review !== '')
                      .map((review, i) => (
                        <Slide key={i}>
                          <StyledReviewReactMarkdown>
                            <ReactMarkdown source={review} />
                          </StyledReviewReactMarkdown>
                        </Slide>
                      ))}
                  </Slides>
                </Carousel>
              )}
            />
            <Media
              query={{ minWidth: theme.lgMinRaw }}
              defaultMatches={isDesktop}
              render={() => (
                <Carousel
                  autoPlay
                  autoPlaySpeed={10000}
                  showDots
                  totalSlides={markdownContent.length - 1}
                  slidesToScroll={5}
                  align="start"
                >
                  <Slides>
                    {markdownContent
                      .slice(1)
                      .filter((review) => review !== '')
                      .map((review, i) => (
                        <Slide key={i} itemsToShow={5}>
                          <StyledReviewReactMarkdown>
                            <ReactMarkdown source={review} />
                          </StyledReviewReactMarkdown>
                        </Slide>
                      ))}
                  </Slides>
                </Carousel>
              )}
            />
          </>
        )}
      </ReviewCarouselRow>
    </ReviewContainerRow>
  );
};
